<!-- <app-grid-layout class="scroll" *ngIf="gridData && showListingPage" [gridData]="gridData"
  [isChangeDetected]="isChangeDetected" [TableName]="'Employee Master'" [paginationUrl]="paginationUrl"
  [selectedRange]="selectedSizeToShowData" [searchText]="searchString" (refreshDataEmmiter)="refreshData()"
  (showNumberOfRecordsEmmiter)="onSelectSizeData($event)" (deleteDetailEmmiter)="deleteRecords($event)"
  (deleteMultipleRecordsEmmiter)="deleteMultipleRecord($event)" (searchDataEmitter)="searchData($event)"
  (exportEmmiter)="exportReport($event)" (emmitPagination)="pageNavigation($event)" (addRecordEmmiter)="addRecord()"
  (editDetailEmmiter)="editRecord($event)" (LoginDetailEmmiter)="userLogin($event)" (detailsEmmiter)="showDatails($event)"
  (sortAsendingEmmiter)="sortAsending($event)" (sortDesendingEmmiter)="sortDesending($event)"
  (paginationDataEmmiter)="pageChange($event)" (typeTabEmmiter)="typeTabChnage($event)"
  (importFileEmmiter)="gotToImport()">
</app-grid-layout> -->

<app-grid-table class="scroll" *ngIf="gridData && showListingPage" [gridData]="gridData" [isChangeDetected]="isChangeDetected" [TableName]="'Employee Master'" [paginationUrl]="paginationUrl" [selectedRange]="selectedSizeToShowData" [searchText]="searchString" (refreshDataEmmiter)="refreshData()" (showNumberOfRecordsEmmiter)="onSelectSizeData($event)" (deleteDetailEmmiter)="deleteRecords($event)" (deleteMultipleRecordsEmmiter)="deleteMultipleRecord($event)" (searchDataEmitter)="searchData($event)" (exportEmmiter)="exportReport($event)" (emmitPagination)="pageNavigation($event)" (addRecordEmmiter)="addRecord()" (editDetailEmmiter)="editRecord($event)" (LoginDetailEmmiter)="userLogin($event)" (detailsEmmiter)="showDatails($event)" (sortAsendingEmmiter)="sortAsending($event)" (sortDesendingEmmiter)="sortDesending($event)" (paginationDataEmmiter)="pageChange($event)" (typeTabEmmiter)="typeTabChnage($event)" (importFileEmmiter)="gotToImport()" (unlinkDeviceEmmiter)="unlinkDevice($event)"></app-grid-table>

<!-- ------------------------- Show Add Employee master -->

<div class="container modal fade" [style.display]="showAddPopup? 'block' : 'none'">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="addEditBackButton()" />
        <label class="font_semibold fs-18 ml-10 mt-5 black_color">
          <span class="cp" (click)="addEditBackButton()">Employee Master</span>
          /
          <span [style.color]="subModuleButtonColor">{{isEditModeactive?'Edit':'Add New'}}</span>
        </label>
      </div>
    </div>

    <div class="modal-body p-20">
      <ion-row *ngIf="isFirstEmployee">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <label class="formLabelRegularfs16 mb-5 mr-10">This is the First Employee</label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <ion-accordion-group [multiple]="true" #formContainer>
            <ion-accordion value="first" class="mb-10" [ngClass]="employeementRelatedUserForm.valid == false && addSubmitForm ? 'errorBorder':''">
              <ion-item slot="header">
                <label class="font_semibold fs-14">Current Employment Related Information</label>
              </ion-item>
              <div class="p-10" slot="content">
                <form [formGroup]="employeementRelatedUserForm">
                  <ion-row>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Employee Code
                        <span class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="empCode" (input)="checkEmpCode()" />
                        <mat-error *ngIf="employeementRelatedUserForm.controls['empCode'].hasError('required')">Employee Code is required</mat-error>
                      </mat-form-field>

                      <div class="fs-12 mt-15 red-cl font_regular" *ngIf="showErrorMsgOfExistEmpCode&&employeementRelatedUserForm.controls['empCode'].value">Employee Code Already Exists</div>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Employment Category
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select placeholder="Select Employment Category" formControlName="employmentCategory">
                        <ng-option value="Staff">Staff</ng-option>
                        <ng-option value="Worker">Worker</ng-option>
                        <ng-option value="Contractual">Contractual</ng-option>
                        <ng-option value="Trainee">Trainee</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['employmentCategory'].hasError('required')">Employment Category is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Employment Type
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select placeholder="Select Employment Type" formControlName="employmentType">
                        <ng-option value="Probation">Probation</ng-option>
                        <ng-option value="Confirmed">Confirmed</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['employmentType'].hasError('required')">Employment Type is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Retirement Age</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="retirementAge" (input)="checkNumerIsPositiveemployeementRelatedUserForm($event,'retirementAge')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Employee Status
                        <span class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <mat-select placeholder="Select Employee Status" formControlName="empStatus" (selectionChange)="changeEmployeeStatus($event.value)">
                          <mat-option [value]="'Active'">Active</mat-option>
                          <mat-option *ngIf="isEditModeactive && !isFirstEmployee" [value]="'Exited'">Exited</mat-option>
                        </mat-select>
                        <mat-error *ngIf="employeementRelatedUserForm.controls['empStatus'].hasError('required')">Employee Status is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Date Of Joining
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="dateOfJoining" formControlName="dateOfJoining" placeholder="DD/MM/YYYY" />
                        <mat-datepicker-toggle matIconSuffix [for]="dateOfJoining"></mat-datepicker-toggle>
                        <mat-datepicker #dateOfJoining></mat-datepicker>
                        <mat-error *ngIf="employeementRelatedUserForm.controls['dateOfJoining'].hasError('required')">Date Of Joining is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="employeementRelatedUserForm.value.empStatus == 'Exited' && !replacementNotAvailable">
                      <div class="font_semibold fs-16 catalystTextColor mt-35 mb-5">
                        <u (click)="onClickEmployeeReplacement()" class="cp">Employee Replacement</u>
                      </div>
                      <div *ngIf="!replacementNotAvailable"><label *ngIf="!isReplaceEmployeeFilled && addSubmitForm" class="fs-12 red-cl">Employee Replacement is required</label></div>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="employeementRelatedUserForm.value.empStatus == 'Exited' && replacementNotAvailable && !isEmployeeRole">
                      <div>
                        <div class="formLabelRegularfs16 mb-5">
                          Assign reportees to
                          <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                        </div>
                        <ng-select dropdownPosition="bottom" [clearable]="false" placeholder="Select" formControlName="temporaryEmpId">
                          <ng-option [value]="item.id" *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
                        </ng-select>
                        <label class="fs-12 red-cl font_regular" *ngIf="employeementRelatedUserForm.controls['temporaryEmpId'].hasError('required')">Assign reporters to is required</label>
                      </div>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="employeementRelatedUserForm.value.empStatus == 'Exited'">
                      <div class="formLabelRegularfs16 mb-5">
                        Vacant
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-radio-group aria-label="Select an option" formControlName="isVacant">
                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                        <mat-radio-button [value]="false">No</mat-radio-button>
                      </mat-radio-group>
                      <mat-error *ngIf="employeementRelatedUserForm.controls['isVacant'].hasError('required')">Vacant is required</mat-error>
                    </ion-col>
                    <!-- <ion-col size="12" size-sm="6" size-md="3" class="mt-10"
                      *ngIf="employeementRelatedUserForm.value.empStatus == 'Exited'"> -->
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Date Of Resignation
                        <!-- <span *ngIf="!isFirstEmployee"
                          class="red-cl">&nbsp;*</span> -->
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="dateOfResignation" formControlName="dateOfResignation" placeholder="DD/MM/YYYY" [min]="employeementRelatedUserForm.value.dateOfJoining" />
                        <mat-datepicker-toggle matIconSuffix [for]="dateOfResignation"></mat-datepicker-toggle>
                        <mat-datepicker #dateOfResignation></mat-datepicker>
                        <mat-error *ngIf="employeementRelatedUserForm.controls['dateOfResignation'].hasError('required')">Date Of Resignation is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <!-- <ion-col size="12" size-sm="6" size-md="3" class="mt-10"
                      *ngIf="employeementRelatedUserForm.value.empStatus == 'Exited' && employeementRelatedUserForm.value.dateOfResignation != null "> -->
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="employeementRelatedUserForm.value.empStatus == 'Exited'">
                      <div class="formLabelRegularfs14 mb-5">
                        LWD
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="lwd" formControlName="lastWorkingDate" placeholder="DD/MM/YYYY" [min]="employeementRelatedUserForm.value.dateOfResignation" />
                        <mat-datepicker-toggle matIconSuffix [for]="lwd"></mat-datepicker-toggle>
                        <mat-datepicker #lwd></mat-datepicker>
                        <mat-error *ngIf="employeementRelatedUserForm.controls['lastWorkingDate'].hasError('required')">LWD is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Group Name
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select [addTag]="true" placeholder="Select Group Name" formControlName="groupName">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfGroupNameOfComp">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['groupName'].hasError('required')">Group Name is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Company Name
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select [addTag]="true" placeholder="Select Company Name" formControlName="companyName">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfCompanyNameOfComp">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['companyName'].hasError('required')">Company Name is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Official Email
                        <span class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type here" class="font_regular" formControlName="officialEmail" (blur)="checkEmailInTheSystem()" />
                        <mat-error *ngIf="employeementRelatedUserForm.controls['officialEmail'].hasError('required')">Official Email is required</mat-error>
                        <mat-error *ngIf="employeementRelatedUserForm.controls['officialEmail'].hasError('pattern')">Enter Valid Official Email</mat-error>
                      </mat-form-field>
                      <div class="fs-12 mt-15 red-cl font_regular" *ngIf="showErrorMsgOfExistEmail">Official Email Already Exists</div>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
                      <div class="formLabelRegularfs14 mb-5">
                        Reporting Manager Name
                        <span class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select [clearable]="false" placeholder="Select Manager Name" formControlName="reportingManagerName" (change)="onSelectionOfManager()">
                        <ng-option [value]="item.id" *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['reportingManagerName'].hasError('required')">Reporting Manager Name is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
                      <div class="formLabelRegularfs14 mb-5">
                        Reporting Manager Code
                        <span class="red-cl">&nbsp;*</span>
                      </div>
                      <div class="inputBox notAllowed">{{employeementRelatedUserForm.value.reportingManagerCode}}</div>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['reportingManagerName'].hasError('required')">Reporting Manager Code is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
                      <div class="formLabelRegularfs14 mb-5">Dotted Reporting Manager Name</div>
                      <ng-select placeholder="Select Dotted Reporting Manager Name" formControlName="dottedReportingManagerName" (change)="onSelectionOfDottedManager()">
                        <ng-option [value]="item.id" *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
                      </ng-select>
                      <!-- <label class="fs-12 red-cl font_regular"
                        *ngIf="addSubmitForm && employeementRelatedUserForm.controls['dottedReportingManagerName'].hasError('required')">Dotted
                        Reporting Manager Code
                        is required</label> -->
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
                      <div class="formLabelRegularfs14 mb-5">Dotted Reporting Manager Code</div>
                      <div class="inputBox notAllowed">{{employeementRelatedUserForm.value.dottedReportingManagerCode}}</div>
                      <!-- <label class="fs-12 red-cl font_regular"
                        *ngIf="addSubmitForm && employeementRelatedUserForm.controls['dottedReportingManagerCode'].hasError('required')">Dotted
                        Reporting Manager Code
                        is required</label> -->
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
                      <div class="formLabelRegularfs14 mb-5">
                        HOD Name
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select [clearable]="false" placeholder="Select HOD Name" formControlName="hodName" (change)="onSelectionOfHod()">
                        <ng-option [value]="item.id" *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['hodName'].hasError('required')">HOD Name is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
                      <div class="formLabelRegularfs14 mb-5">
                        HOD Code
                        <span class="red-cl">&nbsp;*</span>
                      </div>
                      <div class="inputBox notAllowed">{{employeementRelatedUserForm.value.hodCode}}</div>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['hodCode'].hasError('required')">HOD Code is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Band
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select [addTag]="true" placeholder="Select Band" formControlName="band">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfBandNameOfComp">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['band'].hasError('required')">Band is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Grade
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select [addTag]="true" placeholder="Select Grade" formControlName="grade">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfGradeNameOfComp">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['grade'].hasError('required')">Grade is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Designation
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select [addTag]="true" placeholder="Select Designation" formControlName="designation">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfDesignationsOfComp">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['designation'].hasError('required')">Designation is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Department/Function
                        <span class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select [addTag]="true" placeholder="Select Department/Function" formControlName="department">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfDepartmentsOfComp">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['department'].hasError('required')">Department/Function is required</label>
                    </ion-col>
                    <!-- Plant Location -->
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" >
                      <div class="formLabelRegularfs14 mb-5">
                        Plant Location
                        <span class="red-cl">&nbsp;</span>
                      </div>

                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type here" class="font_regular" formControlName="plantLocation" />
                        <!-- <mat-error
                        *ngIf="employeementRelatedUserForm.controls['plantLocation'].hasError('required')">
                        Plant Location is required
                      </mat-error> -->
                      </mat-form-field>
                    </ion-col>

                    <!-- Group Weekly Off -->
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Group Weekly Off
                        <span class="red-cl">&nbsp;</span>
                      </div>

                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type here" class="font_regular" formControlName="groupWeeklyOff" />
                        <!-- <mat-error
                        *ngIf="employeementRelatedUserForm.controls['groupWeeklyOff'].hasError('required')">
                        Group Weekly Off is required
                      </mat-error> -->
                      </mat-form-field>
                    </ion-col>

                    <!-- Department -->
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Sub Department/Sub Function</div>
                      <ng-select [addTag]="true" placeholder="Select Sub Department/Sub Function" formControlName="subDepartment">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfSubDepartmentsOfComp">{{item.name}}</ng-option>
                      </ng-select>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Work Location-State
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select dropdownPosition="top" placeholder="Select Work Location-State" formControlName="workLocationState">
                        <ng-option [value]="item" *ngFor="let item of states">{{item}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['workLocationState'].hasError('required')">Work Location-State is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Work Location- City/ Town
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="workLocationCity" />
                        <mat-error *ngIf="employeementRelatedUserForm.controls['workLocationCity'].hasError('required')">Work Location- City/ Town is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <!-- <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Catalyst Role</div>
                      <ng-select placeholder="Select Catalyst Role" formControlName="catalystRole">
                        <ng-option value="HR Admin">HR Admin</ng-option>
                        <ng-option value="Admin">Admin</ng-option>
                      </ng-select>
                    </ion-col> -->
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Designation at DOJ
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select dropdownPosition="top" [addTag]="true" placeholder="Select Designation at DOJ" formControlName="designationAtDoj">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfDesignationsAtDOJOfComp">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && employeementRelatedUserForm.controls['designationAtDoj'].hasError('required')">Designation at DOJ is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">No. of Promotions/ Upgrades</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input type="number" matInput placeholder="Type number here" class="font_regular" formControlName="noOfPromotions" (input)="checkNumerIsPositiveemployeementRelatedUserForm($event,'noOfPromotions')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Current Individual Performance Score</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="currentPerformanceScore" (input)="checkNumerIsPositiveemployeementRelatedUserForm($event,'currentPerformanceScore')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Current Individual Performance Rating</div>
                      <ng-select dropdownPosition="top" [addTag]="true" placeholder="Select" formControlName="currentPerformanceRating">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfCurrentRatingOfComp">{{item.name}}</ng-option>
                      </ng-select>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last Year Individual Performance Score</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="lastYearPerformanceScore" (input)="checkNumerIsPositiveemployeementRelatedUserForm($event,'lastYearPerformanceScore')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last Year Individual Performance Rating</div>
                      <ng-select dropdownPosition="top" [addTag]="true" placeholder="Select" formControlName="lastYearPerformanceRating">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfLastYearRatingOfComp">{{item.name}}</ng-option>
                      </ng-select>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Year Before Last Year Individual Performance Score</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="yearBeforeLastYearPerformanceScore" (input)="checkNumerIsPositiveemployeementRelatedUserForm($event,'yearBeforeLastYearPerformanceScore')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Year Before Last Year Individual Performance Rating</div>
                      <ng-select dropdownPosition="top" [addTag]="true" placeholder="Select" formControlName="yearBeforeLastYearPerformanceRating">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfLastToLastYearRatingOfComp">{{item.name}}</ng-option>
                      </ng-select>
                    </ion-col>
                  </ion-row>
                </form>
              </div>
            </ion-accordion>
            <ion-accordion value="second" class="mb-10" [ngClass]="generalInformationUserForm.valid == false && addSubmitForm ? 'errorBorder':''">
              <ion-item slot="header">
                <label class="font_semibold fs-14">General Information</label>
              </ion-item>
              <div class="p-10" slot="content">
                <form [formGroup]="generalInformationUserForm">
                  <ion-row>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Salutation
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select dropdownPosition="bottom" placeholder="Select Salutation" formControlName="salutation">
                        <ng-option value="Mr.">Mr.</ng-option>
                        <ng-option value="Mrs.">Mrs.</ng-option>
                        <ng-option value="Ms.">Ms.</ng-option>
                        <ng-option value="Dr.">Dr.</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && generalInformationUserForm.controls['salutation'].hasError('required')">Salutation is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        First Name
                        <span class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="firstName" />
                        <mat-error *ngIf="generalInformationUserForm.controls['firstName'].hasError('required')">First Name is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Last Name
                        <span class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="lastName" />
                        <mat-error *ngIf="generalInformationUserForm.controls['lastName'].hasError('required')">First Name is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Gender
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select dropdownPosition="bottom" placeholder="Select Gender" formControlName="gender">
                        <ng-option value="Male">Male</ng-option>
                        <ng-option value="Female">Female</ng-option>
                        <ng-option value="Cannot_Disclose">Don't wish to disclose</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && generalInformationUserForm.controls['gender'].hasError('required')">Gender is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Country
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select dropdownPosition="bottom" placeholder="Select Country" formControlName="country">
                        <ng-option [value]="item.id" *ngFor="let item of getCountryList">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && generalInformationUserForm.controls['country'].hasError('required')">Gender is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Present Address
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-input-style">
                        <textarea matInput placeholder="Type text here" formControlName="address"></textarea>
                        <mat-error *ngIf="generalInformationUserForm.controls['address'].hasError('required')">Present Address is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Permanent Address</div>
                      <mat-form-field class="w-100 mat-input-style">
                        <textarea matInput placeholder="Type text here" formControlName="permanentAddress"></textarea>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Marital Status</div>
                      <ng-select placeholder="Select Marital Status" formControlName="maritalStatus">
                        <ng-option value="Married">Married</ng-option>
                        <ng-option value="Single">Single</ng-option>
                      </ng-select>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="generalInformationUserForm.value.maritalStatus == 'Married'">
                      <div class="formLabelRegularfs14 mb-5">Date of Marriage</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="dateOfMarriage" [max]="currentDate" formControlName="dateOfMarriage" placeholder="DD/MM/YYYY" />
                        <mat-datepicker-toggle matIconSuffix [for]="dateOfMarriage"></mat-datepicker-toggle>
                        <mat-datepicker #dateOfMarriage></mat-datepicker>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Date of Birth
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="dateOfBirth" [max]="currentDate" formControlName="dateOfBirth" placeholder="DD/MM/YYYY" (dateChange)="calculateAgeFromDOB()" />
                        <mat-datepicker-toggle matIconSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
                        <mat-datepicker #dateOfBirth></mat-datepicker>
                        <mat-error *ngIf="generalInformationUserForm.controls['dateOfBirth'].hasError('required')">Date of Birth is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Age</div>
                      <div class="inputBox notAllowed">{{generalInformationUserForm.value.age}}</div>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Personal Email</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="personalEmail" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        AdharCard No.
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input type="number" matInput placeholder="Type number here" class="font_regular" formControlName="aadharNo" (input)="checkNumerIsPositivgeneralInformationUserForm($event,'aadharNo');checkAadharNo()" />
                        <mat-error *ngIf="generalInformationUserForm.controls['aadharNo'].hasError('required')">AdharCard No. is required</mat-error>
                        <mat-error *ngIf="generalInformationUserForm.controls['aadharNo'].hasError('pattern')">Enter Valid AdharCard No.</mat-error>
                      </mat-form-field>
                      <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistAddharNo">AdharCard No. Already Exists</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        PAN No.
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input maxlength="10" matInput placeholder="Type text here" class="font_regular" formControlName="panNo" (input)="checkPanNo()" />
                        <mat-error *ngIf="generalInformationUserForm.controls['panNo'].hasError('required')">PAN No. is required</mat-error>
                        <mat-error *ngIf="generalInformationUserForm.controls['panNo'].hasError('pattern')">Enter Valid PAN No.</mat-error>
                      </mat-form-field>
                      <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistPAN">PAN No. Already Exists</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">UAN No.</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="uan" (input)="checkNumerIsPositivgeneralInformationUserForm($event,'uan');checkUanNo()" />
                        <mat-error *ngIf="generalInformationUserForm.controls['uan'].hasError('pattern')">Enter Valid UAN No.</mat-error>
                      </mat-form-field>
                      <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistUAN">UAN No. Already Exists</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Mobile No (Whats app No.)
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="contactNo" (input)="checkNumerIsPositivgeneralInformationUserForm($event,'contactNo')" />
                        <mat-error *ngIf="generalInformationUserForm.controls['contactNo'].hasError('required')">Mobile No. is required</mat-error>
                        <mat-error *ngIf="generalInformationUserForm.controls['contactNo'].hasError('pattern')">Enter Valid Mobile No.</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Total Previous Experience Before Joining</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="totalExperience" (input)="checkNumerIsPositivgeneralInformationUserForm($event,'totalExperience')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Emergency Contact Number</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="emergencyContactNo" (input)="checkNumerIsPositivgeneralInformationUserForm($event,'emergencyContactNo')" />
                        <mat-error *ngIf="generalInformationUserForm.controls['emergencyContactNo'].hasError('pattern')">Enter Valid Emergency Contact Number</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Blood Group</div>
                      <ng-select dropdownPosition="top" placeholder="Select Marital Status" formControlName="bloodGroup">
                        <ng-option value="A+">A+</ng-option>
                        <ng-option value="AB+">AB+</ng-option>
                        <ng-option value="O+">O+</ng-option>
                        <ng-option value="B-">B-</ng-option>
                        <ng-option value="AB-">AB-</ng-option>
                        <ng-option value="A-">A-</ng-option>
                        <ng-option value="B+">B+</ng-option>
                        <ng-option value="O-">O-</ng-option>
                        <ng-option value="A1+">A1+</ng-option>
                        <ng-option value="A1B+">A1B+</ng-option>
                        <ng-option value="A1-">A1-</ng-option>
                        <ng-option value="A2B+">A2B+</ng-option>
                        <ng-option value="A2-">A2-</ng-option>
                        <ng-option value="A1B-">A1B-</ng-option>
                        <ng-option value="A2+">A2+</ng-option>
                        <ng-option value="A2B-">A2B-</ng-option>
                      </ng-select>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Father's Name</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="fathersName" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Mother's Name</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="mothersName" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Spouse's Name</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="spouseName" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">No. of Children</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="noOfChildren" (input)="checkNumerIsPositivgeneralInformationUserForm($event,'noOfChildren')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Is Relative Working?</div>
                      <ng-select dropdownPosition="top" [clearable]="false" placeholder="Select" formControlName="isRelativeWorking">
                        <ng-option [value]="true">Yes</ng-option>
                        <ng-option [value]="false">No</ng-option>
                      </ng-select>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="generalInformationUserForm.value.isRelativeWorking == true">
                      <div class="formLabelRegularfs14 mb-5">Name of Relative Working</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="workingRelativeName" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="generalInformationUserForm.value.isRelativeWorking == true">
                      <div class="formLabelRegularfs14 mb-5">Relation of Relative Working</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="workingRelativeRelation" />
                      </mat-form-field>
                    </ion-col>
                  </ion-row>
                </form>
              </div>
            </ion-accordion>
            <ion-accordion value="third" class="mb-10" [ngClass]="educationRelatedInformationUserForm.valid == false && addSubmitForm ? 'errorBorder':''">
              <ion-item slot="header">
                <label class="font_semibold fs-14">Education Related Information</label>
              </ion-item>
              <div class="p-10" slot="content">
                <form [formGroup]="educationRelatedInformationUserForm">
                  <ion-row>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Highest Education Qualification</div>
                      <ng-select dropdownPosition="bottom" [addTag]="true" placeholder="Select Highest Education Qualification" formControlName="highestEducationQualification">
                        <ng-option [value]="item.id" *ngFor="let item of getListOfHighestQualificationOfComp">{{item.name}}</ng-option>
                      </ng-select>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Highest Education Institute</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationInstitute" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Highest Education Year of Passing</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="highestEducationYearOfPassing" (input)="checkNumerIsPositiveeducationRelatedInformationUserForm($event,'highestEducationYearOfPassing')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Highest Education Marks/ %ge</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationMarks" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">2nd Highest Education Qualification</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationQualification2" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">2nd Highest Education Institute</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationInstitute2" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">2nd Highest Education Year of Passing</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="highestEducationYearOfPassing2" (input)="checkNumerIsPositiveeducationRelatedInformationUserForm($event,'highestEducationYearOfPassing2')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">2nd Highest Education Marks/ %ge</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationMarks2" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">3rd Highest Education Qualification</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationQualification3" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">3rd Highest Education Institute</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationInstitute3" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">3rd Highest Education Year of Passing</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="highestEducationYearOfPassing3" (input)="checkNumerIsPositiveeducationRelatedInformationUserForm($event,'highestEducationYearOfPassing3')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">3rd Highest Education Marks/ %ge</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationMarks3" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Highest Professional Qualification</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestProfessionalQualification" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Highest Professional Institute</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestProfessionalInstitute" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Highest Professional Year of Passing</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="highestProfessionalYearOfPassing" (input)="checkNumerIsPositiveeducationRelatedInformationUserForm($event,'highestProfessionalYearOfPassing')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Highest Professional Marks/ %ge</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="highestProfessionalMarks" />
                      </mat-form-field>
                    </ion-col>
                  </ion-row>
                </form>
              </div>
            </ion-accordion>
            <ion-accordion value="fourth" class="mb-10" [ngClass]="salaryRelatedInformationUserForm.valid == false && addSubmitForm ? 'errorBorder':''">
              <ion-item slot="header">
                <label class="font_semibold fs-14">Salary Related</label>
              </ion-item>
              <div class="p-10" slot="content">
                <form [formGroup]="salaryRelatedInformationUserForm">
                  <ion-row>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Currency</div>
                      <ng-select dropdownPosition="bottom" [addTag]="true" placeholder="Select Currency" formControlName="currency">
                        <ng-option [value]="item.id" *ngFor="let item of getCurrencyList">{{item.name}}</ng-option>
                      </ng-select>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Salary Status
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select dropdownPosition="bottom" placeholder="Select Salary Status" formControlName="salaryStatus">
                        <ng-option value="Process">Process</ng-option>
                        <ng-option value="Hold">Hold</ng-option>
                        <ng-option value="FF">F&F</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && salaryRelatedInformationUserForm.controls['salaryStatus'].hasError('required')">Salary Status is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Bank Name
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select dropdownPosition="bottom" [addTag]="true" placeholder="Select Bank Name" formControlName="bankName">
                        <ng-option [value]="item.id" *ngFor="let item of getBankNameList">{{item.name}}</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && salaryRelatedInformationUserForm.controls['bankName'].hasError('required')">Bank Name is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Bank Branch Address
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="bankBranchAddress" />
                        <mat-error *ngIf="salaryRelatedInformationUserForm.controls['bankBranchAddress'].hasError('required')">Bank Branch Address is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Bank Account No.
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <!-- <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="bankAccount"
                          (blur)="checkAccountNo()" (input)="checkNumerIsPositive($event,'bankAccount')"> -->
                        <input matInput type="text" placeholder="Type number here" class="font_regular" formControlName="bankAccount" (blur)="checkAccountNo()" (keypress)="restrictNonNumeric($event)" />
                        <mat-error *ngIf="salaryRelatedInformationUserForm.controls['bankAccount'].hasError('required')">Bank Account No. is required</mat-error>
                      </mat-form-field>
                      <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistAccountNo">Bank Account No. Already Exists</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        IFSC Code
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="ifscCode" />
                        <mat-error *ngIf="salaryRelatedInformationUserForm.controls['ifscCode'].hasError('required')">IFSC Code is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Effective Date
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="effectiveDate" formControlName="effectiveDate" placeholder="DD/MM/YYYY" />
                        <mat-datepicker-toggle matIconSuffix [for]="effectiveDate"></mat-datepicker-toggle>
                        <mat-datepicker #effectiveDate></mat-datepicker>
                        <mat-error *ngIf="salaryRelatedInformationUserForm.controls['effectiveDate'].hasError('required')">Effective Date is required</mat-error>
                      </mat-form-field>
                    </ion-col>

                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Basic Salary PM
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="basicSalaryPm" (input)="checkNumerIsPositive($event,'basicSalaryPm')" />
                        <mat-error *ngIf="salaryRelatedInformationUserForm.controls['basicSalaryPm'].hasError('required')">Basic Salary PM is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Dearness Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="daPm" (input)="checkNumerIsPositive($event,'daPm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">HRA PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="hraPm" (input)="checkNumerIsPositive($event,'hraPm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Other Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="otherAllowancePm" (input)="checkNumerIsPositive($event,'otherAllowancePm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">LTA PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="ltaPm" (input)="checkNumerIsPositive($event,'ltaPm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Medical Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="medicalAllowancePm" (input)="checkNumerIsPositive($event,'medicalAllowancePm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Washing Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="washingAllowancePm" (input)="checkNumerIsPositive($event,'washingAllowancePm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Special Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="specialAllowancePm" (input)="checkNumerIsPositive($event,'specialAllowancePm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Fuel/Petrol Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="fuelAllowancePm" (input)="checkNumerIsPositive($event,'fuelAllowancePm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Entertainment Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="entertainmentAllowancePm" (input)="checkNumerIsPositive($event,'entertainmentAllowancePm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Education Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="educationAllowancePm" (input)="checkNumerIsPositive($event,'educationAllowancePm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Books and Periodical Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="booksAllowancePm" (input)="checkNumerIsPositive($event,'booksAllowancePm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Statutory Bonus Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="statutoryBonusPm" (input)="checkNumerIsPositive($event,'statutoryBonusPm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Any Other Allowance PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="anyOtherAllowancePm" (input)="checkNumerIsPositive($event,'anyOtherAllowancePm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Gross Salary PM
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="grossSalaryPm" (input)="checkNumerIsPositive($event,'grossSalaryPm')" />
                        <mat-error *ngIf="salaryRelatedInformationUserForm.controls['grossSalaryPm'].hasError('required')">Gross Salary PM is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Employee PF PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="employeePfPm" (input)="checkNumerIsPositive($event,'employeePfPm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Employer PF PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="employerPfPm" (input)="checkNumerIsPositive($event,'employerPfPm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">PT PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="ptPm" (input)="checkNumerIsPositive($event,'ptPm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">LWF PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="lwfPm" (input)="checkNumerIsPositive($event,'lwfPm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">ESIC PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="esicPm" (input)="checkNumerIsPositive($event,'esicPm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Any Other Retiral PM</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="otherRetiralPm" (input)="checkNumerIsPositive($event,'otherRetiralPm')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Total Retiral PM
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="totalRetiralPm" (input)="checkNumerIsPositive($event,'totalRetiralPm')" />
                        <mat-error *ngIf="salaryRelatedInformationUserForm.controls['totalRetiralPm'].hasError('required')">Total Retiral PM is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Fixed CTC Including Retirals PM
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="monthlyCTC" (input)="checkNumerIsPositive($event,'monthlyCTC')" />
                        <mat-error *ngIf="salaryRelatedInformationUserForm.controls['monthlyCTC'].hasError('required')">Fixed CTC Including Retirals PM is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Fixed CTC Including Retirals PA
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="annualCTC" (input)="checkNumerIsPositive($event,'annualCTC')" />
                        <mat-error *ngIf="salaryRelatedInformationUserForm.controls['annualCTC'].hasError('required')">Fixed CTC Including Retirals PA is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Process of Giving VP
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select placeholder="Select Salary Status" formControlName="processOfVp">
                        <ng-option value="Fixed VP">Fixed VP</ng-option>
                        <ng-option value="No VP">No VP</ng-option>
                        <ng-option value="%ge on CTC">%ge on CTC</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && salaryRelatedInformationUserForm.controls['processOfVp'].hasError('required')">Process of Giving VP is required</label>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Annual Variable Pay Budget</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="annualVariablePayBudget" (input)="checkNumerIsPositive($event,'annualVariablePayBudget')" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Annual Total CTC (fixed CTC + annual variable pay budget)
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="annualTotalCtc" (input)="checkNumerIsPositive($event,'annualTotalCtc')" />
                        <mat-error *ngIf="salaryRelatedInformationUserForm.controls['annualTotalCtc'].hasError('required')">Annual Total CTC (fixed CTC + annual variable pay budget) is required</mat-error>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">
                        Increment on Fixed Annual CTC or Total Annual CTC
                        <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                      </div>
                      <ng-select dropdownPosition="top" placeholder="Select Salary Status" formControlName="incrementOn">
                        <ng-option value="Fixed Annual CTC">Fixed Annual CTC</ng-option>
                        <ng-option value="Total Annual CTC">Total Annual CTC</ng-option>
                      </ng-select>
                      <label class="fs-12 red-cl font_regular" *ngIf="addSubmitForm && salaryRelatedInformationUserForm.controls['incrementOn'].hasError('required')">Increment on Fixed Annual CTC or Total Annual CTC is required</label>
                    </ion-col>
                  </ion-row>
                </form>
              </div>
            </ion-accordion>
            <ion-accordion value="fifth" class="mb-10" [ngClass]="priorEmploymentRelatedInformationUserForm.valid == false && addSubmitForm ? 'errorBorder':''">
              <ion-item slot="header">
                <label class="font_semibold fs-14">Prior Employment Related</label>
              </ion-item>
              <div class="p-10" slot="content">
                <form [formGroup]="priorEmploymentRelatedInformationUserForm">
                  <ion-row>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last Organisation Before Joining</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="lastOrganisationName" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last organisation Date Of Joining</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="lastorgdateOfJoining" [max]="currentDate" formControlName="lastOrganisationDoj" placeholder="DD/MM/YYYY" />
                        <mat-datepicker-toggle matIconSuffix [for]="lastorgdateOfJoining"></mat-datepicker-toggle>
                        <mat-datepicker #lastorgdateOfJoining></mat-datepicker>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last organisation Last Working Of Date</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="lastorglwd" [min]="priorEmploymentRelatedInformationUserForm.value.lastOrganisationDoj" [max]="currentDate" placeholder="DD/MM/YYYY" formControlName="lastOrganisationLwd" />
                        <mat-datepicker-toggle matIconSuffix [for]="lastorglwd"></mat-datepicker-toggle>
                        <mat-datepicker #lastorglwd></mat-datepicker>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last organisation Department</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="lastOrganisationDepartment" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last organisation Designation</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="lastOrganisationDesignation" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Before Joining</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="lastToLastOrganisationName" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Date Of Joining</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="lasttolastorgdateOfJoining" [max]="currentDate" placeholder="DD/MM/YYYY" formControlName="lastToLastOrganisationDoj" />
                        <mat-datepicker-toggle matIconSuffix [for]="lasttolastorgdateOfJoining"></mat-datepicker-toggle>
                        <mat-datepicker #lasttolastorgdateOfJoining></mat-datepicker>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Last Working Of Date</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="lasttolastorglwd" [min]="priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationDoj" [max]="currentDate" placeholder="DD/MM/YYYY" formControlName="lastToLastOrganisationLwd" />
                        <mat-datepicker-toggle matIconSuffix [for]="lasttolastorglwd"></mat-datepicker-toggle>
                        <mat-datepicker #lasttolastorglwd></mat-datepicker>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Department</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="lastToLastOrganisationDepartment" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Designation</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="lastToLastOrganisationDesignation" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Any Other Organisation Joined Before</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="otherOrganisationName" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Any Other Organisation Date Of Joining</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="anyOtherorgdateOfJoining" [max]="currentDate" placeholder="DD/MM/YYYY" formControlName="otherOrganisationDoj" />
                        <mat-datepicker-toggle matIconSuffix [for]="anyOtherorgdateOfJoining"></mat-datepicker-toggle>
                        <mat-datepicker #anyOtherorgdateOfJoining></mat-datepicker>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Any Other Organisation Last Working Of Date</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input readonly matInput [matDatepicker]="anyOtherorglwd" [min]="priorEmploymentRelatedInformationUserForm.value.otherOrganisationDoj" [max]="currentDate" placeholder="DD/MM/YYYY" formControlName="otherOrganisationLwd" />
                        <mat-datepicker-toggle matIconSuffix [for]="anyOtherorglwd"></mat-datepicker-toggle>
                        <mat-datepicker #anyOtherorglwd></mat-datepicker>
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Any Other Organisation Department</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="otherOrganisationDepartment" />
                      </mat-form-field>
                    </ion-col>
                    <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                      <div class="formLabelRegularfs14 mb-5">Any Other Organisation Designation</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput placeholder="Type text here" class="font_regular" formControlName="otherOrganisationDesignation" />
                      </mat-form-field>
                    </ion-col>
                  </ion-row>
                </form>
              </div>
            </ion-accordion>
            <ion-accordion value="sixth" class="mb-10">
              <ion-item slot="header">
                <label class="font_semibold fs-14">Additional Field</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngFor="let item of customFieldObject">
                    <div class="formLabelRegularfs14 mb-5">{{item.fieldName}}</div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <input matInput placeholder="Type text here" class="font_regular" [(ngModel)]="item.fieldValue" />
                    </mat-form-field>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-col>
      </ion-row>
      <div class="clear10"></div>
      <ion-row>
        <ion-col size="12" class="mt-15 mb-15">
          <button (click)="backBtn()" class="back_btn fs-14">Cancel</button>
          <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName " (click)="onClickAddUser()">{{isEditModeactive?'Update':'Add'}}</button>
        </ion-col>
      </ion-row>
      <div class="clear40"></div>
      <!-- <form [formGroup]="userForm">
        <ion-row>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Employee ID<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style" [ngClass]="{'notAllowed' : isFirstEmployee}">
              <input [attr.readonly]="isFirstEmployee ? true : false" [ngClass]="{'notAllowed' : isFirstEmployee}"
                [disabled]="isFirstEmployee" matInput placeholder="Type text here" class="font_regular"
                formControlName="empCode">
              <mat-error *ngIf="userForm.controls['empCode'].hasError('required')">Employee ID is required</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">First Name<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type text here" class="font_regular" formControlName="firstName">
              <mat-error *ngIf="userForm.controls['firstName'].hasError('required')">First Name is required</mat-error>
              <mat-error *ngIf="userForm.controls['firstName'].hasError('pattern')">First Name should be alphabetic
                characters</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Last Name<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type text here" class="font_regular" formControlName="lastName">
              <mat-error *ngIf="userForm.controls['lastName'].hasError('required')">Last Name is required</mat-error>
              <mat-error *ngIf="userForm.controls['lastName'].hasError('pattern')">Last Name should be alphabetic
                characters</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"></ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Gender<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-radio-group aria-label="Select an option" formControlName="gender">
              <mat-radio-button [value]="'Male'">Male</mat-radio-button>
              <mat-radio-button [value]="'Female'">Female</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="userForm.controls['gender'].hasError('required')">Gender is required</mat-error>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Present Address</div>
            <mat-form-field class="w-100 mat-input-style">
              <textarea matInput placeholder="Type text here" formControlName="address"></textarea>
              <mat-error *ngIf="userForm.controls['address'].hasError('required')">Present Address is
                required</mat-error>
            </mat-form-field>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Marital Status</div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" formControlName="maritalStatus">
                <mat-option [value]="'Unmarried'">Unmarried</mat-option>
                <mat-option [value]="'Married'">Married</mat-option>
                <mat-option [value]="'Widowed'">Widowed</mat-option>
                <mat-option [value]="'Divorced'">Divorced</mat-option>
              </mat-select>
              <mat-error *ngIf="userForm.controls['maritalStatus'].hasError('required')">Marital Status is
                required</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"></ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Date of Birth</div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input readonly matInput [matDatepicker]="dateOfBirth" placeholder="MM/DD/YYYY"
                formControlName="dateOfBirth">
              <mat-error *ngIf="userForm.controls['dateOfBirth'].hasError('required')">Date of Birth is
                required</mat-error>
              <mat-datepicker-toggle matIconSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
              <mat-datepicker #dateOfBirth></mat-datepicker>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Date of Joining<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input readonly matInput [matDatepicker]="dateOfJoining" placeholder="MM/DD/YYYY"
                formControlName="dateOfJoining">
              <mat-error *ngIf="userForm.controls['dateOfJoining'].hasError('required')">Date of Joining is
                required</mat-error>
              <mat-datepicker-toggle matIconSuffix [for]="dateOfJoining"></mat-datepicker-toggle>
              <mat-datepicker #dateOfJoining></mat-datepicker>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Company Name</div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type text here" class="font_regular" formControlName="companyName">
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"></ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Official Email ID<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type here" class="font_regular" formControlName="officialEmail">
              <mat-error *ngIf="userForm.controls['officialEmail'].hasError('required')">Official Email ID is
                required</mat-error>
              <mat-error *ngIf="userForm.controls['officialEmail'].hasError('pattern')">Please Enter Correct Official
                Email ID</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Personal Email ID</div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type here" class="font_regular" formControlName="personalEmail">
              <mat-error *ngIf="userForm.controls['personalEmail'].hasError('required')">Personal Email ID is
                required</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Aadhaar No.</div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput type="number" placeholder="Type number here" class="font_regular"
                formControlName="aadharNo">
              <mat-error *ngIf="userForm.controls['aadharNo'].hasError('pattern')">Aadhaar No. is invalid</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"></ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">UAN</div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input type="number" matInput placeholder="Type text here" class="font_regular" formControlName="uan">
              <mat-error *ngIf="userForm.controls['uan'].hasError('pattern')">UAN is invalid</mat-error>
            </mat-form-field>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
            <div class="formLabelRegularfs16 mb-5">Reporting Manager Name<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <ng-select [clearable]="false"placeholder="Select" formControlName="reportingManagerName"
            (change)="onSelectionOfManager()">
              <ng-option [value]="item.id"
                *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
            </ng-select>
            <label class="fs-12 red-cl font_regular" *ngIf="userForm.controls['reportingManagerName'].hasError('required')">Reporting Manager Name
              is required</label>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
            <div class="formLabelRegularfs16 mb-5">Reporting Manager Code<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <div class="inputBox notAllowed">{{userForm.value.reportingManagerCode}}</div>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee"></ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
            <div class="formLabelRegularfs16 mb-5">Dotted Reporting Manager Name</div>
            <ng-select [clearable]="false"placeholder="Select" formControlName="dottedReportingManagerName"
            (change)="onSelectionOfDottedManager()">
              <ng-option [value]="item.id"
                *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
            </ng-select>
            <label class="fs-12 red-cl font_regular" *ngIf="userForm.controls['dottedReportingManagerName'].hasError('required')">Dotted Reporting
              Manager Name is required</label>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
            <div class="formLabelRegularfs16 mb-5">Dotted Reporting Manager Code</div>
            <div class="inputBox notAllowed">{{userForm.value.dottedReportingManagerCode}}</div>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
            <div class="formLabelRegularfs16 mb-5">HOD Name<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <ng-select [clearable]="false"placeholder="Select" formControlName="hodName"
            (change)="onSelectionOfHod()">
              <ng-option [value]="item.id"
                *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
            </ng-select>
            <label class="fs-12 red-cl font_regular" *ngIf="userForm.controls['hodName'].hasError('required')">HOD Name is required</label>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee"></ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="!isFirstEmployee">
            <div class="formLabelRegularfs16 mb-5">HOD Code<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <div class="inputBox notAllowed">{{userForm.value.hodCode}}</div>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Band<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type text here" class="font_regular" formControlName="band">
              <mat-error *ngIf="userForm.controls['band'].hasError('required')">Band is required</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Grade<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type text here" class="font_regular" formControlName="grade">
              <mat-error *ngIf="userForm.controls['grade'].hasError('required')">Grade is required</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"></ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Function<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type text here" class="font_regular" formControlName="function">
              <mat-error *ngIf="userForm.controls['function'].hasError('required')">Function is required</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Designation<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type text here" class="font_regular" formControlName="designation">
              <mat-error *ngIf="userForm.controls['designation'].hasError('required')">Designation is
                required</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Mobile Number<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input type="number" matInput placeholder="Type number here" class="font_regular"
                formControlName="contactNo">
              <mat-error *ngIf="userForm.controls['contactNo'].hasError('required')">Mobile Number is
                required</mat-error>
              <mat-error *ngIf="userForm.controls['contactNo'].hasError('pattern')">Please Enter Correct Mobile
                Number</mat-error>
            </mat-form-field>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"></ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Department<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type text here" class="font_regular" formControlName="department">
              <mat-error *ngIf="userForm.controls['department'].hasError('required')">Department is required</mat-error>
            </mat-form-field>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Plant / Office Location<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type text here" class="font_regular" formControlName="officeLocation">
              <mat-error *ngIf="userForm.controls['officeLocation'].hasError('required')">Plant / Office Location is
                required</mat-error>
            </mat-form-field>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Total Experience (Previous)</div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input type="number" matInput placeholder="Type number here" class="font_regular"
                formControlName="totalExperience">
              <mat-error *ngIf="userForm.controls['totalExperience'].hasError('required')">Total Experience (Previous)
                is required</mat-error>
            </mat-form-field>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"></ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Emergency Contact Number</div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput type="number" placeholder="Type number here" class="font_regular"
                formControlName="emergencyContactNo">
              <mat-error *ngIf="userForm.controls['emergencyContactNo'].hasError('required')">Emergency Contact Number
                is required</mat-error>
              <mat-error *ngIf="userForm.controls['emergencyContactNo'].hasError('pattern')">Please Enter Correct
                Emergency
                Number</mat-error>
            </mat-form-field>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Highest Qualification</div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput placeholder="Type text here" class="font_regular" formControlName="qualification">
              <mat-error *ngIf="userForm.controls['qualification'].hasError('required')">Highest Qualification is
                required</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Monthly CTC<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput type="number" placeholder="Type number here" class="font_regular"
                formControlName="monthlyCTC">
              <mat-error *ngIf="userForm.controls['monthlyCTC'].hasError('required')">Monthly CTC is
                required</mat-error>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"></ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Annual CTC<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput type="number" placeholder="Type number here" class="font_regular"
                formControlName="annualCTC">
              <mat-error *ngIf="userForm.controls['annualCTC'].hasError('required')">Annual CTC is required</mat-error>
            </mat-form-field>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Employee Status<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" formControlName="empStatus"
                (selectionChange)="changeEmployeeStatus($event.value)">
                <mat-option [value]="'Active'">Active</mat-option>
                <mat-option *ngIf="isEditModeactive && !isFirstEmployee" [value]="'Exited'">Exited</mat-option>
              </mat-select>
              <mat-error *ngIf="userForm.controls['empStatus'].hasError('required')">Employee Status is
                required</mat-error>
            </mat-form-field>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"
            *ngIf="userForm.value.empStatus == 'Exited'">
            <div class="formLabelRegularfs16 mb-5">Date Of Resignation<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input readonly matInput [matDatepicker]="dateOfResignation" placeholder="MM/DD/YYYY"
                formControlName="dateOfResignation" [min]="userForm.value.dateOfJoining"
                (dateChange)="onDateOfResignationChange($event)">
              <mat-error *ngIf="userForm.controls['dateOfResignation'].hasError('required')">Date Of Resignation is
                required</mat-error>
              <mat-datepicker-toggle matIconSuffix [for]="dateOfResignation"></mat-datepicker-toggle>
              <mat-datepicker #dateOfResignation></mat-datepicker>
            </mat-form-field>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"></ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"
            *ngIf="userForm.value.empStatus == 'Exited' && userForm.value.dateOfResignation != null">
            <div class="formLabelRegularfs16 mb-5">LWD<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input readonly matInput [matDatepicker]="lastWorkingDate" placeholder="MM/DD/YYYY"
                formControlName="lastWorkingDate" [min]="userForm.value.dateOfResignation">
              <mat-error *ngIf="userForm.controls['lastWorkingDate'].hasError('required')">LWD is
                required</mat-error>
              <mat-datepicker-toggle matIconSuffix [for]="lastWorkingDate"></mat-datepicker-toggle>
              <mat-datepicker #lastWorkingDate></mat-datepicker>
            </mat-form-field>
          </ion-col>


          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"
            *ngIf="userForm.value.empStatus == 'Exited' && replacementNotAvailable">
            <div class="formLabelRegularfs16 mb-5">Vacant<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
            <mat-radio-group aria-label="Select an option" formControlName="isVacant">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false">No</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="userForm.controls['isVacant'].hasError('required')">Vacant is required</mat-error>
          </ion-col>

          <ion-col size="12" size-sm="6" size-md="3" class="mt-10"
            *ngIf="userForm.value.empStatus == 'Exited'">
            <div *ngIf="!replacementNotAvailable" class="font_semibold fs-16 catalystTextColor mt-35 mb-5">
              <u (click)="onClickEmployeeReplacement()" class="cp">Employee Replacement</u>
            </div>
            <div *ngIf="!replacementNotAvailable"><label *ngIf="!isReplaceEmployeeFilled && addSubmitForm"
                class="fs-12 red-cl">Employee Replacement is required</label></div>
            <div *ngIf="replacementNotAvailable">
              <div class="formLabelRegularfs16 mb-5">Assign reportees to<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
              <ng-select [clearable]="false"placeholder="Select" formControlName="temporaryEmpId">
                <ng-option [value]="item.id"
                  *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
              </ng-select>
              <label class="fs-12 red-cl font_regular" *ngIf="userForm.controls['temporaryEmpId'].hasError('required')">Assign reporters to is required</label>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="mt-15">
            <button (click)="backBtn()" class="back_btn fs-14">Cancel</button>
            <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName "
              (click)="onClickAddUser()">{{isEditModeactive?'Update':'Add'}}</button>
          </ion-col>
        </ion-row>
        <div class="clear50"></div>
      </form> -->
    </div>
  </div>
</div>

<!-- -------------------------- Show details Employee Master ---------------------------------------------- -->

<div class="container modal fade" [style.display]="showDetailsPopup? 'block' : 'none'">
  <div class="modal-dialog">
    <div class="modal-content">
      <ion-row class="p-0 headerBreadcrumb">
        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="p-0">
          <div class="d-flex pt-5 pb-10 pr-10 pl-0">
            <img src="././assets/icon/backArrow.svg" class="cp" (click)="backbtnWithoutConfirmation()" />
            <label class="font_semibold fs-18 ml-10 mt-5 black_color">
              <span class="cp" (click)="backbtnWithoutConfirmation()">Employee Master</span>
              /
              <span [style.color]="subModuleButtonColor">{{empCode}}</span>
            </label>
          </div>
        </ion-col>
        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="p-0 text-right">
          <div class="d-inline-flex p-5" *ngIf="loggedInUserRole != 'Admin'">
            <span class="cp fs-14 link font_regular center-content mr-10" (click)="onClickLogs('Employee Master')">
              <img src="././assets/icon/logsIcon.svg" />
              <u>Logs</u>
            </span>
            <img (click)="editEmployeeData()" src="././assets/icon/editIconOrange.svg" class="ml-10 mr-10 cp" />
          </div>
        </ion-col>
      </ion-row>
    </div>
    <div class="modal-body p-20">
      <ion-row *ngIf="isFirstEmployee">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <label class="formLabelRegularfs16 mb-5 mr-10">This is the First Employee</label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0" *ngFor="let item of employeeData">
          <ion-accordion-group [multiple]="true">
            <ion-accordion value="first" class="mb-10">
              <ion-item slot="header">
                <label class="font_semibold fs-14">Current Employment Related Information</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Employee Code
                      <span class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.empCode}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Employment Category
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.employmentCategory}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Employment Type
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.employmentType}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Retirement Age</div>
                    <div class="formLabelBoldfs14">{{item.retirementAge}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Employee Status
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.empStatus}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Date Of Joining
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.dateOfJoining | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="item.empStatus == 'Exited'">
                    <div class="formLabelRegularfs16 mb-5">
                      Vacant
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.isVacant?'Yes':'No'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="item.empStatus == 'Exited'">
                    <div class="formLabelRegularfs14 mb-5">
                      Date Of Resignation
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.dateOfResignation | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="item.empStatus == 'Exited'">
                    <div class="formLabelRegularfs14 mb-5">
                      LWD
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.lastWorkingDate | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Group Name
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.groupName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Company Name
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.companyName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Official Email
                      <span class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.officialEmail}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Reporting Manager Name
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.reportingManager?.firstName}} {{item.reportingManager?.lastName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Reporting Manager Code
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.reportingManager?.employeeId}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Dotted Reporting Manager Name</div>
                    <div class="formLabelBoldfs14">{{item.dottedReportingManager?.firstName}} {{item.dottedReportingManager?.lastName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Dotted Reporting Manager Code</div>
                    <div class="formLabelBoldfs14">{{item.dottedReportingManager?.employeeId}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      HOD Name
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.hod?.firstName}} {{item.hod?.lastName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      HOD Code
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.hod?.employeeId}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Band
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.band}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Grade
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.grade}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Designation
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.designation}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Department/Function
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.department}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Plant Location
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;</span>
                    </div>

                    <div class="formLabelBoldfs14">{{ item.plantLocation }}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Group Weekly Off
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.groupWeeklyOff}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Sub Department/Sub Function</div>
                    <div class="formLabelBoldfs14">{{item.subDepartment}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Work Location-State
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.workLocationState}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Work Location- City/ Town
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.workLocationCity}}</div>
                  </ion-col>
                  <!-- <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Catalyst Role</div>
                    <div class="formLabelBoldfs14">{{item.catalystRole}}</div>
                  </ion-col> -->
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Designation at DOJ
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.designationAtDoj}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">No. of Promotions/ Upgrades</div>
                    <div class="formLabelBoldfs14">{{item.noOfPromotions}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Current Individual Performance Score</div>
                    <div class="formLabelBoldfs14">{{item.currentPerformanceScore}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Current Individual Performance Rating</div>
                    <div class="formLabelBoldfs14">{{item.currentPerformanceRating}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last Year Individual Performance Score</div>
                    <div class="formLabelBoldfs14">{{item.lastYearPerformanceScore}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last Year Individual Performance Rating</div>
                    <div class="formLabelBoldfs14">{{item.lastYearPerformanceRating}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Year Before Last Year Individual Performance Score</div>
                    <div class="formLabelBoldfs14">{{item.yearBeforeLastYearPerformanceScore}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Year Before Last Year Individual Performance Rating</div>
                    <div class="formLabelBoldfs14">{{item.yearBeforeLastYearPerformanceRating}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
            <ion-accordion value="second" class="mb-10">
              <ion-item slot="header">
                <label class="font_semibold fs-14">General Information</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Salutation
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.salutation}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      First Name
                      <span class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.firstName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Last Name
                      <span class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.lastName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Gender
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.gender}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Country
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.country}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Present Address
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.address}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Permanent Address</div>
                    <div class="formLabelBoldfs14">{{item.permanentAddress}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Marital Status</div>
                    <div class="formLabelBoldfs14">{{item.maritalStatus}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="item.maritalStatus == 'Married'">
                    <div class="formLabelRegularfs14 mb-5">Date of Marriage</div>
                    <div class="formLabelBoldfs14">{{item.dateOfMarriage | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Date of Birth
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.dateOfBirth | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Age</div>
                    <div class="formLabelBoldfs14">{{item.age}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Personal Email</div>
                    <div class="formLabelBoldfs14">{{item.email}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      AdharCard No.
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.aadharNo}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      PAN No.
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.panNo}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">UAN No.</div>
                    <div class="formLabelBoldfs14">{{item.uan}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Mobile No (Whats app No.)
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.contactNo}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Total Previous Experience Before Joining</div>
                    <div class="formLabelBoldfs14">{{item.totalExperience}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Emergency Contact Number</div>
                    <div class="formLabelBoldfs14">{{item.emergencyContactNo}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Blood Group</div>
                    <div class="formLabelBoldfs14">{{item.bloodGroup}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Father's Name</div>
                    <div class="formLabelBoldfs14">{{item.fathersName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Mother's Name</div>
                    <div class="formLabelBoldfs14">{{item.mothersName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Spouse's Name</div>
                    <div class="formLabelBoldfs14">{{item.spouseName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">No. of Children</div>
                    <div class="formLabelBoldfs14">{{item.noOfChildren}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Is Relative Working?</div>
                    <div class="formLabelBoldfs14">{{item.isRelativeWorking?'Yes':'No'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="item.isRelativeWorking == true">
                    <div class="formLabelRegularfs14 mb-5">Name of Relative Working</div>
                    <div class="formLabelBoldfs14">{{item.workingRelativeName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngIf="item.isRelativeWorking == true">
                    <div class="formLabelRegularfs14 mb-5">Relation of Relative Working</div>
                    <div class="formLabelBoldfs14">{{item.workingRelativeRelation}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
            <ion-accordion value="third" class="mb-10">
              <ion-item slot="header">
                <label class="font_semibold fs-14">Education Related Information</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Education Qualification</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationQualification}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Education Institute</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationInstitute}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Education Year of Passing</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationYearOfPassing}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Education Marks/ %ge</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationMarks}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">2nd Highest Education Qualification</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationQualification2}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">2nd Highest Education Institute</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationInstitute2}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">2nd Highest Education Year of Passing</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationYearOfPassing2}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">2nd Highest Education Marks/ %ge</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationMarks2}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">3rd Highest Education Qualification</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationQualification3}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">3rd Highest Education Institute</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationInstitute3}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">3rd Highest Education Year of Passing</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationYearOfPassing3}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">3rd Highest Education Marks/ %ge</div>
                    <div class="formLabelBoldfs14">{{item.highestEducationMarks3}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Professional Qualification</div>
                    <div class="formLabelBoldfs14">{{item.highestProfessionalQualification}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Professional Institute</div>
                    <div class="formLabelBoldfs14">{{item.highestProfessionalInstitute}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Professional Year of Passing</div>
                    <div class="formLabelBoldfs14">{{item.highestProfessionalYearOfPassing}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Professional Marks/ %ge</div>
                    <div class="formLabelBoldfs14">{{item.highestProfessionalMarks}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>

            <ion-accordion value="fourth" class="mb-10" *ngIf="(checkSalaryDetailsView|| ['Super Admin','HR Admin','PHI Admin','MD'].includes(loggedInUserRole) )">
              <ion-item slot="header">
                <label class="font_semibold fs-14">Salary Related</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Currency</div>
                    <div class="formLabelBoldfs14">{{item.currency}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Salary Status
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.salaryStatus}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Bank Name
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.bankName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Bank Branch Address
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.bankBranchAddress}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Bank Account No.
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.bankAccount}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      IFSC Code
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.ifscCode}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Effective Date
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.effectiveDate | date : "dd-MM-yyyy"}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Basic Salary PM
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.basicSalaryPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Dearness Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.daPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">HRA PM</div>
                    <div class="formLabelBoldfs14">{{item.hraPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Other Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.otherAllowancePm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">LTA PM</div>
                    <div class="formLabelBoldfs14">{{item.ltaPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Medical Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.medicalAllowancePm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Washing Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.washingAllowancePm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Special Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.specialAllowancePm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Fuel/Petrol Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.fuelAllowancePm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Entertainment Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.entertainmentAllowancePm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Education Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.educationAllowancePm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Books and Periodical Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.booksAllowancePm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Statutory Bonus Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.statutoryBonusPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Allowance PM</div>
                    <div class="formLabelBoldfs14">{{item.anyOtherAllowancePm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Gross Salary PM
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.grossSalaryPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Employee PF PM</div>
                    <div class="formLabelBoldfs14">{{item.employeePfPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Employer PF PM</div>
                    <div class="formLabelBoldfs14">{{item.employerPfPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">PT PM</div>
                    <div class="formLabelBoldfs14">{{item.ptPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">LWF PM</div>
                    <div class="formLabelBoldfs14">{{item.lwfPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">ESIC PM</div>
                    <div class="formLabelBoldfs14">{{item.esicPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Retiral PM</div>
                    <div class="formLabelBoldfs14">{{item.otherRetiralPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Total Retiral PM
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.totalRetiralPm}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Fixed CTC Including Retirals PM
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.monthlyCtc}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Fixed CTC Including Retirals PA
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.annualCtc}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Process of Giving VP
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.processOfVp}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Annual Variable Pay Budget</div>
                    <div class="formLabelBoldfs14">{{item.annualVariablePayBudget}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Annual Total CTC (fixed CTC + annual variable pay budget)
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.annualTotalCtc}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">
                      Increment on Fixed Annual CTC or Total Annual CTC
                      <span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="formLabelBoldfs14">{{item.incrementOn}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
            <ion-accordion value="fifth" class="mb-10">
              <ion-item slot="header">
                <label class="font_semibold fs-14">Prior Employment Related</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last Organisation Before Joining</div>
                    <div class="formLabelBoldfs14">{{item.lastOrganisationName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last organisation Date Of Joining</div>
                    <div class="formLabelBoldfs14">{{item.lastOrganisationDoj | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last organisation Last Working Of Date</div>
                    <div class="formLabelBoldfs14">{{item.lastOrganisationLwd | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last organisation Department</div>
                    <div class="formLabelBoldfs14">{{item.lastOrganisationDepartment}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last organisation Designation</div>
                    <div class="formLabelBoldfs14">{{item.lastOrganisationDesignation}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Before Joining</div>
                    <div class="formLabelBoldfs14">{{item.lastToLastOrganisationName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Date Of Joining</div>
                    <div class="formLabelBoldfs14">{{item.lastToLastOrganisationDoj | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Last Working Of Date</div>
                    <div class="formLabelBoldfs14">{{item.lastToLastOrganisationLwd | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Department</div>
                    <div class="formLabelBoldfs14">{{item.lastToLastOrganisationDepartment}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Designation</div>
                    <div class="formLabelBoldfs14">{{item.lastToLastOrganisationDesignation}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Organisation Joined Before</div>
                    <div class="formLabelBoldfs14">{{item.otherOrganisationName}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Organisation Date Of Joining</div>
                    <div class="formLabelBoldfs14">{{item.otherOrganisationDoj | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Organisation Last Working Of Date</div>
                    <div class="formLabelBoldfs14">{{item.otherOrganisationLwd | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Organisation Department</div>
                    <div class="formLabelBoldfs14">{{item.otherOrganisationDepartment}}</div>
                  </ion-col>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Organisation Designation</div>
                    <div class="formLabelBoldfs14">{{item.otherOrganisationDesignation}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
            <ion-accordion value="sixth" class="mb-10" *ngIf="checkSalaryDetailsView ||['Super Admin','HR Admin','PHI Admin','MD'].includes(loggedInUserRole)">
              <ion-item slot="header">
                <label class="font_semibold fs-14">Additional Field</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size="12" size-sm="6" size-md="3" class="mt-10" *ngFor="let data of item.customValues">
                    <div class="formLabelRegularfs14 mb-5">{{data.fieldName}}</div>
                    <div class="formLabelBoldfs14">{{data.fieldValue}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-col>
      </ion-row>
      <div class="clear50"></div>
      <!-- <div class="detailsCardBox">
        <div class="headingOfShowBox">
          <ion-row class="p-0">
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="p-0">
              <div class="font_semibold fs-16">Employee Details</div>
            </ion-col>
          </ion-row>
        </div>
        <div class="p-10" *ngFor="let item of employeeData">
          <ion-row class="mb-10">
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Employee ID</div>
              <div class="formLabelBoldfs16">{{item.empCode}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">First Name</div>
              <div class="formLabelBoldfs16">{{item.firstName}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Last Name</div>
              <div class="formLabelBoldfs16">{{item.lastName}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Employee Status</div>
              <div class="formLabelBoldfs16">{{item.empStatus}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Gender</div>
              <div class="formLabelBoldfs16">{{item.gender}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Present Address</div>
              <div class="formLabelBoldfs16">{{item.address}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Marital Status</div>
              <div class="formLabelBoldfs16">{{item.maritalStatus}}</div>
            </ion-col>


            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Date of Birth</div>
              <div class="formLabelBoldfs16">{{item.dateOfBirth | date: 'dd-MM-yyyy'}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Date of Joining</div>
              <div class="formLabelBoldfs16">{{item.dateOfJoining | date: 'dd-MM-yyyy'}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12" *ngIf="item.empStatus == 'Exited'">
              <div class="formLabelRegularfs16">LWD</div>
              <div class="formLabelBoldfs16">{{item.lastWorkingDate | date: 'dd-MM-yyyy'}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12" *ngIf="item.empStatus == 'Exited'">
              <div class="formLabelRegularfs16">Date Of Resignation</div>
              <div class="formLabelBoldfs16">{{item.dateOfResignation | date: 'dd-MM-yyyy'}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12" *ngIf="item.empStatus == 'Exited'">
              <div class="formLabelRegularfs16">Vacant</div>
              <div class="formLabelBoldfs16">{{item?.isVacant?'Yes':'No'}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Company Name</div>
              <div class="formLabelBoldfs16">{{item.companyName}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Official Email ID</div>
              <div class="formLabelBoldfs16">{{item.officialEmail}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Personal Email ID</div>
              <div class="formLabelBoldfs16">{{item.email}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Aadhaar No.</div>
              <div class="formLabelBoldfs16">{{item.aadharNo}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">UAN</div>
              <div class="formLabelBoldfs16">{{item.uan}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Reporting Manager Name</div>
              <div class="formLabelBoldfs16">{{item.reportingManager?.firstName}} {{item.reportingManager?.lastName}}
              </div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Reporting Manager Code</div>
              <div class="formLabelBoldfs16">{{item.reportingManagerCode}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Dotted Reporting Manager Name</div>
              <div class="formLabelBoldfs16">{{item.dottedReportingManager?.firstName}}
                {{item.dottedReportingManager?.lastName}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Dotted Reporting Manager Code</div>
              <div class="formLabelBoldfs16">{{item.dottedReportingManagerCode}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">HOD Name</div>
              <div class="formLabelBoldfs16">{{item.hod?.firstName}} {{item.hod?.lastName}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">HOD Code</div>
              <div class="formLabelBoldfs16">{{item.hodCode}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Band</div>
              <div class="formLabelBoldfs16">{{item.band}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Grade</div>
              <div class="formLabelBoldfs16">{{item.grade}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Function</div>
              <div class="formLabelBoldfs16">{{item.empFunction}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Designation</div>
              <div class="formLabelBoldfs16">{{item.designation}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Mobile Number</div>
              <div class="formLabelBoldfs16">{{item.contactNo}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Department</div>
              <div class="formLabelBoldfs16">{{item.department}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Plant / Office Location</div>
              <div class="formLabelBoldfs16">{{item.location}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Total Experience (Previous)</div>
              <div class="formLabelBoldfs16">{{item.totalExperience}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Emergency Contact Number</div>
              <div class="formLabelBoldfs16">{{item.emergencyContactNo}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Highest Qualification</div>
              <div class="formLabelBoldfs16">{{item.qualification}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Monthly CTC</div>
              <div class="formLabelBoldfs16">{{item.monthlyCtc}}</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs16">Annual CTC</div>
              <div class="formLabelBoldfs16">{{item.annualCtc}}</div>
            </ion-col>
          </ion-row>
        </div>
      </div> -->
      <div class="clear50"></div>
    </div>
  </div>
</div>
